
import "/app/apps/accounts/src/components/right-content/index.less?modules";
export default {"search": `search-vZ1hGjD8`,"account": `account-QaNIBmxt`,"avatar": `avatar-67Yt5A-g`,"companyName": `companyName-nA5cC_WN`,"menu": `menu-_j-Knljv`,"right": `right-o-6I-Nlu`,"action": `action-YOzkfLeD`}
